
import { LibService } from 'src/app/services/libService';

import { CompanyService } from 'src/app/services/companyService';
import { Component, ElementRef, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { combineLatest, map, tap, Observable, switchMap, of } from 'rxjs';
import { TargetsService } from 'src/app/services/targets.service';
import { AddEvent, CancelEvent, CellClickEvent, EditEvent, RemoveEvent, SaveEvent } from '@progress/kendo-angular-grid';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { process } from '@progress/kendo-data-query';
import { SocietyService } from 'src/app/services/societyService';

const createFormGroup = (dataItem: any) =>
  new UntypedFormGroup({
    id: new UntypedFormControl(dataItem.id),
    type: new UntypedFormControl(dataItem.type),
    description: new UntypedFormControl(dataItem.description),
    year: new UntypedFormControl(dataItem.year),
    january: new UntypedFormControl(dataItem.january),      //1
    february: new UntypedFormControl(dataItem.february),     //2
    march: new UntypedFormControl(dataItem.march),        //3
    april: new UntypedFormControl(dataItem.april),        //4
    may: new UntypedFormControl(dataItem.may),          //5
    june: new UntypedFormControl(dataItem.june),         //6
    july: new UntypedFormControl(dataItem.july),         //7
    august: new UntypedFormControl(dataItem.august),       //8
    september: new UntypedFormControl(dataItem.september),    //9
    october: new UntypedFormControl(dataItem.october),      //10
    november: new UntypedFormControl(dataItem.november),     //11
    december: new UntypedFormControl(dataItem.december),     //12
    company: new UntypedFormControl(dataItem.company),
  });
@Component({
  selector: 'app-company-targets',
  templateUrl: './company-targets.component.html',
  styleUrls: ['./company-targets.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CompanyTargetsComponent implements OnInit {

  year = new Date().getFullYear();
  maxLengthYear = 4;
  maxLengthMonth = 2;
  decimals = 0;
  decimals2 = 2;
  maxMonth = 12;
  month = ["january","february","march","april","may","june","july","august","september","october","november","december"];

  d = new Date();
  currentMonth = this.month[this.d.getMonth()];

  formAll: UntypedFormGroup;
  formType: UntypedFormGroup;
  formEdit: UntypedFormGroup;
  formCompanyTargets: UntypedFormGroup;

  societies: any;
  companies: any;
  types: any;
  companyTargets: any;
  editRowIndex: any;
  event: any;

  whileEditing: boolean = false;
  visible: boolean  = false;

  companyTarget: any;

  selectedType: any;
  selectedYear: any;
  save: boolean = false;
  years: any[] = [];
  months: any[] = [];

  targetCommit$: Observable<any>;
  formTypeChange$: Observable<any>;
  targetTypes$ = this.targetService.getTargetTypesCompany();
  companies$ = this.companyService.getAllCompaniesForRequest().pipe(
    map((companies: any[]) => {
      return companies.sort((a, b) => a.name.toUpperCase() <= b.name.toUpperCase() ? -1 : 1)
    }),
    tap(companies => {
      this.companies = [...new Set(companies)]//TODO: FIX
      this.companies.push({id: 0, code: null, name: ''})
    })
  );
  societies$ = this.societyService.getAllSocieties();

  constructor(public targetService: TargetsService,
              public fb: UntypedFormBuilder,
              public companyService:CompanyService,
              private libService: LibService,
              public elementRef: ElementRef,
              public societyService: SocietyService)
  {
    this.allData = this.allData.bind(this);
    this.generateYearArray();
    this.formCompanyTargets = this.fb.group({
      id: [null],
      type: [null],
      description: [null],
      year: [null],
      january: [null],      //1
      february: [null],     //2
      march: [null],        //3
      april: [null],        //4
      may: [null],          //5
      june: [null],         //6
      july: [null],         //7
      august: [null],       //8
      september: [null],    //9
      october: [null],      //10
      november: [null],     //11
      december: [null],     //12
      company: [null]
    });
    this.formEdit = this.fb.group({
      ...this.formCompanyTargets.controls
    });
    this.formAll = this.fb.group({
      ...this.formCompanyTargets.controls
    });
    this.formType = this.fb.group({
      targetType: [null],
      year: [null]
    });

    this.formTypeChange$ = this.formType.valueChanges.pipe(switchMap( (val: any) => {
      this.libService.lockPage('');
      this.selectedYear = val.year;
      this.selectedType = val.targetType;
      this.selectedType && this.selectedYear? this.visible = true: this.visible = false;
      if (this.visible) {

        return this.targetService.getCompanyTargetsByTargetAndYear(this.selectedType, this.selectedYear).pipe(tap( val => this.libService.unlockPage()));
      } else {
        this.libService.unlockPage();
        return of(null) as Observable<any>;

      }

    }));
  }

  ngOnInit(): void {

    this.libService.lockPage('');
    combineLatest([this.targetTypes$, this.companies$, this.societies$]).subscribe({
      next: ([targetTypes, companies, societies]: any) => {
        this.types = targetTypes;
        this.companies = companies;
        this.societies = societies;
        console.log("SOCIETA --> ", this.societies);
        console.log("COMPANIES --> ", this.companies);
        this.formType.patchValue({
          targetType: this.types[0],
          year: this.years[0]
        })
        this.libService.unlockPage();
      }
    });

    this.formTypeChange$.subscribe({
      next: res => {
        console.log("RESPONSE COMPANY BY TARGETS --> ", res);
        this.companyTargets = res;
        this.companyTargets?
          this.companyTargets.sort((a: any, b: any) =>  a.month-b.month):
          console.log();
        this.event? this.event.sender.closeRow(this.editRowIndex): undefined;
        this.libService.unlockPage();
      }
    });
  }

  addHandler(e: AddEvent){
    let body = {};
    let array: any[] = [];
    this.whileEditing = true;
    this.companies.forEach((company: any) => {
      this.years.forEach((year: any) => {
        console.log("COMPANY INSIDE LOOP --> ", company);
        body = { type: this.selectedType.description, year: year, company: company };
        array.push(body);
      });
    });
    console.log("OGGETTO DA SALVARE --> ", array);
    this.targetService.createCompanyTargetFromArray(array).subscribe(val => {
      console.log(val);
    });

  }

  saveHandler(e: any) {
    console.log("CLICK SALVA");
    this.whileEditing = false;

    this.companyTarget = this.formCompanyTargets.getRawValue();
    this.targetCommit$ = this.targetService.updateCompanyTarget(this.companyTarget);

    this.libService.lockPage(' ');
    console.log("EVENTO SALVA --> ", e);
    let calls = this.targetCommit$.pipe(switchMap((val:any) => {

      e.sender.closeRow(e.rowIndex);
      return this.targetService.getCompanyTargetsByTargetAndYear(this.selectedType, this.selectedYear);
    }));

    calls.subscribe((val: any) => {
      this.companyTargets = val;
      // console.log("COMPANY TARGETS --> ", this.companyTargets);

      this.companyTargets? this.companyTargets.sort((a: any, b: any) =>  a.month-b.month): undefined;
      this.libService.unlockPage();
    })
    this.formCompanyTargets.reset;
  }

  cancelHandler(e: CancelEvent) {
    this.whileEditing = false;
    // console.log("EVENTO CANEL --> ", e);
    e.sender.closeRow(e.rowIndex);
  }

  editHandler(e: EditEvent) {
    this.whileEditing = true;
    console.log("DATI DA MODIFICARE --> ", e.dataItem);
    // for (const property in e.dataItem) {
    //    (property.toLowerCase().includes("date") && e.dataItem[property] !== null)?
    //     e.dataItem[property] = new Date(e.dataItem[property]): undefined;
    // }
    this.formCompanyTargets.patchValue(e.dataItem);
    // console.log("FORM DI TUTTO --> ", this.formAll);
    // this.formClaims.patchValue({
    //   type: e.dataItem.type?.claimType,
    //   claimStatus: e.dataItem.claimStatus?.claimStatus
    // });
    // console.log("FORM CLAIMS --> ", this.formClaims);
    e.sender.editRow(e.rowIndex, this.formCompanyTargets);
  }

  generateYearArray() {
    const moment = require('moment');
    let yToPush = this.year;
    let i = 1;

    for(let i = 0; i <= 10; i++) {
      this.years.push(yToPush);
      yToPush++;
    }

    // moment.locale('it'); // sets words language (optional if current locale is to be used)
    // moment.months() // returns a list of months in the current locale (January, February, etc.)
    // moment.months().forEach((element: any ) => {
    //   this.months.push({name: element, number: i});
    //   i++;
    // });

  }

  public editClick(e: CellClickEvent) {
    this.event = e;
    if (this.save) {
      this.saveCurrent(e);
      this.save = false;
    } else {
      console.log("CLICK RIGA");
      this.whileEditing = true;
      let idOld = this.formCompanyTargets.get('id')?.value;
      this.formEdit = createFormGroup(e.dataItem);
      idOld? this.companyTarget = this.formCompanyTargets.getRawValue(): e.sender.editRow(e.rowIndex, this.formEdit);;
      this.formCompanyTargets.patchValue(e.dataItem);
      console.log("CHIUDI RIGA ", this.editRowIndex);
      this.editRowIndex !== undefined? e.sender.closeRow(this.editRowIndex): undefined;


      console.log("APRI RIGA ", e.rowIndex);
      e.sender.editRow(e.rowIndex, this.formEdit);
      this.editRowIndex = e.rowIndex;
      this.formCompanyTargets = this.formEdit;
  }
  }

  saveCurrent(e: any) {
    this.whileEditing = false;

    this.companyTarget = this.formCompanyTargets.getRawValue();
    this.targetCommit$ = this.targetService.updateCompanyTarget(this.companyTarget);

    this.libService.lockPage(' ');
    let calls = this.targetCommit$.pipe(switchMap((val:any) => {

      return this.targetService.getCompanyTargetsByTargetAndYear(this.selectedType, this.selectedYear);
    }));

    calls.subscribe((val: any) => {
      this.companyTargets = val;
      this.companyTargets? this.companyTargets.sort((a: any, b: any) =>  a.month-b.month): undefined;
      e.sender.closeRow(e.rowIndex);
      this.libService.unlockPage();
    })
    this.formCompanyTargets.reset;
  }

  // saveCurrent(e: any) {
  //   this.targetCommit$ = this.targetService.updateCompanyTarget(this.companyTarget);

  //   this.libService.lockPage(' ');
  //   let calls = this.targetCommit$.pipe(switchMap((val:any) => {
  //     e.sender.closeRow(e.rowIndex);
  //     return this.targetService.getCompanyTargetsByTargetAndYear(this.selectedType, this.selectedYear);
  //   }));

  //   calls.subscribe((val: any) => {
  //     this.companyTargets = val;
  //     // console.log("COMPANY TARGETS --> ", this.companyTargets);
  //     this.companyTargets? this.companyTargets.sort((a: any, b: any) =>  a.month-b.month): undefined;
  //     this.libService.unlockPage();
  //     this.formCompanyTargets.patchValue(e.dataItem);
  //     // console.log("CHIUDI RIGA ", this.editRowIndex);
  //     // this.editRowIndex !== undefined? e.sender.closeRow(this.editRowIndex): undefined;

  //     console.log("APRI RIGA", e.rowIndex);
  //     e.sender.editRow(e.rowIndex, this.formEdit);
  //     // this.editRowIndex = e.rowIndex;
  //     this.formCompanyTargets = this.formEdit;
  //   })
  // }

  public allData(): ExcelExportData {
    const result: ExcelExportData = {
      data: process(this.companyTargets, {
        sort: [{ field: "company", dir: "asc" }],
      }).data,

    };

    return result;
  }

}
